module.exports = __webpack_public_path__ + "static/media/Doc.5d729688.svg";